export default __webpack_public_path__ + "static/anregung-zur-beweglichkeit-1a0c23e57270675818a17e1efdaea1ba.jpg";